module.exports = __webpack_public_path__ + "03_medium_brown.0d699cd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/03_medium_brown.png
// module id = 1Zfb
// module chunks = 0